module.exports = __webpack_public_path__ + "img/ec-logo.2a932e45.svg";